export default function LcapPage() {
	return (
		<div className="container mx-auto max-w-3xl px-4 py-16">
			<h1 className="mb-8 text-3xl font-bold text-slate-900">
				Conformité LCAP
			</h1>
			<p className="mb-6 text-sm text-slate-500">
				Dernière mise à jour : 3 mars 2026
			</p>

			<div className="prose prose-slate max-w-none">
				<h2>1. Qu'est-ce que la LCAP?</h2>
				<p>
					La{' '}
					<em>
						Loi canadienne anti-pourriel
					</em>{' '}
					(LCAP, ou CASL en anglais) est une loi fédérale
					canadienne qui réglemente l'envoi de messages
					électroniques commerciaux (MEC). Elle exige le
					consentement du destinataire avant l'envoi de courriels
					commerciaux.
				</p>

				<h2>2. Comment Vigilio respecte la LCAP</h2>

				<h3>2.1 Double opt-in</h3>
				<p>
					Lorsqu'un destinataire est ajouté à une liste de
					distribution, il reçoit un courriel de confirmation. Il
					doit cliquer sur le lien de confirmation pour passer au
					statut « Confirmé ». Aucun courriel de veille n'est
					envoyé tant que le destinataire n'a pas confirmé son
					consentement.
				</p>

				<h3>2.2 Désabonnement facile</h3>
				<p>
					Chaque courriel envoyé via Vigilio contient un lien de
					désabonnement fonctionnel qui prend effet immédiatement.
					Les destinataires désabonnés ne recevront plus aucun
					courriel de la liste de distribution concernée.
				</p>

				<h3>2.3 Identification de l'expéditeur</h3>
				<p>
					Tous les courriels envoyés identifient clairement
					l'organisation expéditrice et incluent les coordonnées de
					contact requises par la LCAP.
				</p>

				<h2>3. Responsabilités de l'utilisateur</h2>
				<p>
					En tant qu'utilisateur de Vigilio, vous vous engagez à :
				</p>
				<ul>
					<li>
						N'ajouter que des destinataires avec lesquels vous
						avez une relation d'affaires existante ou qui ont
						donné leur consentement explicite
					</li>
					<li>
						Respecter les demandes de désabonnement
					</li>
					<li>
						Maintenir des listes de distribution à jour et retirer
						les adresses invalides
					</li>
					<li>
						Ne pas utiliser le Service pour envoyer des messages
						non sollicités
					</li>
				</ul>

				<h2>4. Mécanismes techniques</h2>
				<ul>
					<li>
						<strong>Statuts des destinataires</strong> : En
						attente → Confirmé → (optionnel) Désabonné
					</li>
					<li>
						<strong>Jeton de confirmation</strong> : Chaque
						invitation contient un jeton unique et sécurisé
					</li>
					<li>
						<strong>Jeton de désabonnement</strong> : Chaque
						courriel contient un jeton de désabonnement unique
					</li>
					<li>
						<strong>Blocage automatique</strong> : Le système
						refuse l'envoi aux destinataires non confirmés ou
						désabonnés
					</li>
				</ul>

				<h2>5. Contact</h2>
				<p>
					Pour toute question concernant notre conformité LCAP :
					<br />
					Themelio Inc.
					<br />
					<a href="mailto:compliance@themelio.ca">
						compliance@themelio.ca
					</a>
				</p>
			</div>
		</div>
	)
}
